import styled from 'styled-components/macro';

export const PageHeadingWrapper = styled.div`
  margin-bottom: 3rem;
`;
